export var ButtonVariantType;
(function (ButtonVariantType) {
    ButtonVariantType["PRIMARY"] = "PRIMARY";
    ButtonVariantType["PRIMARY_EXPANDED"] = "PRIMARY_EXPANDED";
    ButtonVariantType["SECONDARY"] = "SECONDARY";
    ButtonVariantType["SECONDARY_ON_SURFACE"] = "SECONDARY_ON_SURFACE";
    // IconButtonVariants
    ButtonVariantType["ICON_PRIMARY"] = "ICON_PRIMARY";
    ButtonVariantType["ICON_PRIMARY_FILLED"] = "ICON_PRIMARY_FILLED";
    ButtonVariantType["ICON_SECONDARY"] = "ICON_SECONDARY";
    ButtonVariantType["ICON_SECONDARY_FILLED"] = "ICON_SECONDARY_FILLED";
    ButtonVariantType["ICON_MAIN_SECTION"] = "ICON_MAIN_SECTION";
    ButtonVariantType["ICON_SECONDARY_MAIN_SECTION"] = "ICON_SECONDARY_MAIN_SECTION";
    ButtonVariantType["ICON_PRIMARY_ON_SURFACE"] = "ICON_PRIMARY_ON_SURFACE";
    ButtonVariantType["ICON_SECONDARY_ON_SURFACE"] = "ICON_SECONDARY_ON_SURFACE";
    ButtonVariantType["ICON_PRIMARY_CONTACT_CENTER"] = "ICON_PRIMARY_CONTACT_CENTER";
    ButtonVariantType["ICON_SECONDARY_CONTACT_CENTER"] = "ICON_SECONDARY_CONTACT_CENTER";
    // Contact Center
    ButtonVariantType["PRIMARY_CONTACT_CENTER"] = "PRIMARY_CONTACT_CENTER";
    ButtonVariantType["SECONDARY_CONTACT_CENTER"] = "SECONDARY_CONTACT_CENTER";
    ButtonVariantType["PRIMARY_GHOST_CONTACT_CENTER"] = "PRIMARY_GHOST_CONTACT_CENTER";
    // Action Button
    ButtonVariantType["PRIMARY_GHOST"] = "PRIMARY_GHOST";
    ButtonVariantType["SECONDARY_GHOST"] = "SECONDARY_GHOST";
    ButtonVariantType["MAIN_SECTION_HEADER_GHOST"] = "MAIN_SECTION_HEADER_GHOST";
    ButtonVariantType["SECONDARY_ON_SURFACE_GHOST"] = "SECONDARY_ON_SURFACE_GHOST";
})(ButtonVariantType || (ButtonVariantType = {}));
export var ButtonSizeType;
(function (ButtonSizeType) {
    ButtonSizeType["LARGE"] = "LARGE";
    ButtonSizeType["SMALL"] = "SMALL";
    ButtonSizeType["EXTRA_SMALL"] = "EXTRA_SMALL";
    // IconButtonSizes
    ButtonSizeType["ICON_MEDIUM"] = "ICON_MEDIUM";
    ButtonSizeType["ICON_SMALL"] = "ICON_SMALL";
})(ButtonSizeType || (ButtonSizeType = {}));
//# sourceMappingURL=variants.js.map